define.alias("shared/components/shared/image", "calendar/components/shared/image");